import { defineDeckPassive } from '../authoring/index.js';
const DAMAGE_COUNTER = 'damage';
const MAX_DAMAGE = 2;
function counter(value) {
    return Number.isSafeInteger(value) && value >= 0
        ? Math.min(value, MAX_DAMAGE)
        : 0;
}
export const RisingDamagePassive = defineDeckPassive({
    id: 'rising_damage',
    role: 'available',
    presentation: {
        name: 'Нарастающий урон',
        description: 'В конце раунда наносит противнику X урона, затем X растёт на 1 (максимум 2). X начинается с 0 и сбрасывается, когда вы получаете урон.',
        glyph: {
            colors: ['#10213A', '#FE610E', '#FF9916', '#FFC43F', '#FFD863'],
            rows: [
                '..........1.........',
                '....1....121........',
                '...121..1221........',
                '...121..1231..1.....',
                '....1..12231.121....',
                '.......12331.121....',
                '....1..12331.121....',
                '...121.123321.121...',
                '..12211223321.121...',
                '..1221122432211221..',
                '.12322224442222221..',
                '.123222344432223221.',
                '..13333345433333221.',
                '..12333455543432221.',
                '..1233344554343221..',
                '..1222445554344221..',
                '..122244555542221...',
                '...1222445552221....',
                '....11223332211.....',
                '......1111111.......',
            ],
        },
    },
    initialEffect: { vars: { [DAMAGE_COUNTER]: 0 } },
    hooks: {
        onRoundEnd(ctx) {
            if (ctx.effect?.scope.kind !== 'player')
                return;
            const damage = counter(ctx.effect.vars[DAMAGE_COUNTER]);
            const opponentId = ctx.q.opponentOf(ctx.effect.scope.playerId).id;
            ctx.ops.dealDamage({ kind: 'player', playerId: opponentId }, damage);
            if (damage < MAX_DAMAGE) {
                ctx.ops.modifyEffectCounter(ctx.effect.id, DAMAGE_COUNTER, 1, 'round_growth');
            }
        },
        onAnyEvent(ctx, event) {
            if (ctx.effect?.scope.kind !== 'player'
                || event.type !== 'DamageDealt'
                || event.amount <= 0
                || event.target.kind !== 'player'
                || event.target.playerId !== ctx.effect.scope.playerId)
                return;
            const damage = counter(ctx.effect.vars[DAMAGE_COUNTER]);
            if (damage > 0) {
                ctx.ops.modifyEffectCounter(ctx.effect.id, DAMAGE_COUNTER, -damage, 'player_damaged');
            }
        },
    },
});
//# sourceMappingURL=rising_damage.js.map